/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Edit_ButtonInputs */



/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Team_Share_Edit_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_edit_button = /** @type {((inputs?: Team_Share_Edit_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Edit_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Edit")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Edit")
	return /** @type {LocalizedString} */ ("Edit")
});